export const benchmarksEndpoints = {
    process: "/api/benchmarks/generate",
    status: (jobId: string): string => `/api/benchmarks/status/${jobId}`,
} as const;
